import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Class composition with the type roles registered as font sizes.
 *
 * Without this, tailwind-merge files `text-ui` under text colour and drops
 * it whenever a colour such as `text-muted-foreground` shares the call.
 * Project Studio lost its type roles to this three times.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['micro', 'caption', 'ui', 'body', 'title', 'code'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
